import { z } from "zod";

// Payload for POST /admin/settings — create a global or job-level conduit setting.
// scope: 'global' or 'job:<recurring-job-id>' (e.g. job:netacuity-mmdb). is_secret declares whether `value`
// is encrypted at rest. scope + key are bounded to path-segment-safe chars (no '/') so
// GET|PUT|DELETE /admin/settings/{scope}/{key} is unambiguous. Kept JSON-Schema-representable
// (no transform/refine) so it round-trips Zod → JSON Schema → C#.
export const createSettingsRequestSchema = z.object({
  scope: z
    .string()
    .min(1)
    .max(100)
    .regex(
      /^(global|job:[A-Za-z0-9._-]+)$/,
      "scope must be 'global' or 'job:<id>' (id: letters, digits, dot, underscore, hyphen)",
    ),
  key: z
    .string()
    .min(1)
    .max(100)
    .regex(/^[A-Za-z0-9._-]+$/, "key may contain only letters, digits, dot, underscore, hyphen"),
  value: z.string().min(1),
  is_secret: z.boolean(),
});
